import React from 'react'
import { useExportCsv } from '../../hooks/useExportCsv'
import { Params } from '../../packages/blueprint-components/src/useTableHooks'
import { useSelector } from 'react-redux'
import { State } from '../../reducers'
import { MenuItem } from './menu'
import { useLocation } from 'react-router-dom'
import type { EntityId } from '../../types/constants'

const csvAvailableForRoutes = [
    'campaigns',
    'ad-groups',
    'targets',
    'keywords',
    'product-ads',
    'search-terms',
    'placements',
]

export const CSVExportMenuItem = ({ params }: { params: Params }) => {
    const profile = useSelector<State, EntityId | null>((state) => state.user.profile)
    const location = useLocation()
    const endpoint = location.pathname.substring(1)
    const { csvUrl } = useExportCsv({ profile, params, endpoint })
    const downloadCsv = () => {
        window.axios.get(csvUrl, { responseType: 'blob' }).then((res) => {
            const disposition = res.headers['content-disposition'] ?? ''
            const match = disposition.match(/filename="?([^"]+)"?/)
            const filename = match?.[1] ?? `${endpoint}.csv`
            const href = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')
            link.href = href
            link.download = filename
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(href)
        })
    }

    if (!csvAvailableForRoutes.includes(endpoint)) {
        return null
    }

    return <MenuItem onClick={downloadCsv} text="Download CSV" />
}
